module.exports = __webpack_public_path__ + "media/S2E1_RetailVideo.95a06071.mp4";